export const GET_CRITERIA_TAB = 'GET_CRITERIA_TAB';
export const SET_CRITERIA_VALUES = 'SET_CRITERIA_VALUES';
export const CLEAR_CRITERIA_VALUES = 'CLEAR_CRITERIA_VALUES';